import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";
import { SeminarType } from "../../types";

interface Props {
  seminarType: SeminarType;
};

const Item = ({ seminarType }: Props) => {
  return (
    <tr>
      <td className="px-6 py-4">
        <div className="flex items-center">
          <Link to={`/seminarTypes/${seminarType._id}/details`} className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {seminarType.name}
            </div>
            <p className="text-sm text-gray-500 overflow-ellipsis">
              {seminarType.description}
            </p>
          </Link>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {seminarType.createdAt &&
          format(parseISO(seminarType.createdAt), "do MMMM", {
            locale: de,
          })}
      </td>
    </tr>
  );
};

export default Item;
